import { createContext } from 'react';

const appContext = createContext();
const { Provider, Consumer } = appContext;

export { appContext, Provider, Consumer };
